/**
 * Состав пака «outline-pills» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 11 воронок: группы.json, группы 0 (PACK в matrix.py)
  palettes: [
    // 2 из 11 воронок: palette → ближайшая тема по цветам
    { themeId: 'midnight-emerald', weight: 0.18 },
  ],
  fonts: [
    // 4 из 11 воронок: fontId
    { fontId: 'inter', weight: 0.36 },
    // 4 из 11 воронок: fontId
    { fontId: 'lora', weight: 0.36 },
  ],
  screenKinds: [
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.472; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.56 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.086; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.1 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.083
    { kind: 'N2', share: 0.1 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.063
    { kind: 'Q4', share: 0.08 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.058
    { kind: 'N4', share: 0.07 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.045; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.05 },
    // средняя доля экранов по 11 воронкам (признаки.json kinds) 0.035
    { kind: 'N1', share: 0.04 },
  ],
  blocks: [
    // в 11 из 11 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 62 из 97, optionIndicator 88 из 97
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 7 из 11 воронок (признаки.json blocks), подъём 1.41; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 16 из 32
    {
      type: 'multiple_choice',
      weight: 0.64,
      settings: { optionIndicator: 'none' },
    },
    // в 4 из 11 воронок (признаки.json blocks), подъём 6.02
    { type: 'video_embed', weight: 0.36, settings: {} },
    // в 2 из 11 воронок (признаки.json blocks), подъём 7.53
    { type: 'date_picker', weight: 0.18, settings: {} },
    // в 5 из 11 воронок (признаки.json blocks), подъём 1.57
    { type: 'text_field', weight: 0.45, settings: {} },
    // в 2 из 11 воронок (признаки.json blocks), подъём 1.19
    { type: 'height_picker', weight: 0.18, settings: {} },
    // в 2 из 11 воронок (признаки.json blocks), подъём 1.19
    { type: 'weight_picker', weight: 0.18, settings: {} },
  ],
  niches: [
    // 3 из 11 воронок (признаки.json theme)
    { niche: 'ai_companion', weight: 0.27 },
    // 2 из 11 воронок (признаки.json theme)
    { niche: 'hobbies', weight: 0.18 },
    // 2 из 11 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.18 },
  ],
};
